// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media print {
    body * {
      visibility: hidden;
    }
    #printableContent, #printableContent * {
      visibility: visible;
    }
    #printableContent {
      position: absolute;
      left: 0;
      top: 0;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/Pages/Print.css"],"names":[],"mappings":"AAAA;IACI;MACE,kBAAkB;IACpB;IACA;MACE,mBAAmB;IACrB;IACA;MACE,kBAAkB;MAClB,OAAO;MACP,MAAM;IACR;EACF","sourcesContent":["@media print {\n    body * {\n      visibility: hidden;\n    }\n    #printableContent, #printableContent * {\n      visibility: visible;\n    }\n    #printableContent {\n      position: absolute;\n      left: 0;\n      top: 0;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
